module.exports = __webpack_public_path__ + "static/media/health-icon.9e69636f.svg";